import RecapDeals from 'components/Content/Recap/RecapDeals/RecapDeals';

export default RecapDeals;
